export default __webpack_public_path__ + "static/media/ok_verde.124f8b54.png";